import { useContext, useEffect } from "react";
import { ContextAuth } from "../../context";
import { ContextNav } from "../../context/ContextNav";
import { CSvgClose, CSvgReport, CSvgArrowRight, CSvgLogout, CSvgMoon, CSvgClock, CSvgChart, CSvgMinusCircle,CSvgPlusCircle, CSvgHelp, CSvgCog } from "../CSvg";
import { Link, useNavigate } from "react-router-dom";

export const DrowerMenu = () => {
    const CtxNav = useContext(ContextNav)
    const CtxAuth = useContext(ContextAuth)
    const navigate = useNavigate();

    const handelChangeRoute = (link: string) => {
        navigate(link);
        CtxNav.setdisplayMenu(false)
    }

    const handelExit = () => {
        navigate('/');
        localStorage.clear()
        sessionStorage.clear()
        CtxAuth.setUserInfo(null)
        CtxAuth.setIsAuth(false)
        CtxNav.setdisplayMenu(false)
    }

    return (
        <>
            <div onClick={() => { CtxNav.setdisplayMenu(false) }} className={`fixed backdrop-blur-sm bg-[#00000069] left-0 right-0 top-0 bottom-0 duration-500 transition-all ${CtxNav.displayMenu ? 'opacity-100 visible z-[60]' : 'invisible opacity-0 -z-[60]'}`} />
            <div onClick={() => { CtxNav.setdisplayMenu(false) }} className={`fixed cursor-pointer ${CtxNav.displayMenu ? 'right-[300px] top-[30px] z-[65] duration-300 delay-200' : 'right-[-500px] -z-[65]'}`}><CSvgClose className='w-[30px] fill-[#fff]' /></div>
            <div className={`fixed w-[280px] px-[30px] top-0 bottom-0 bg-white text-gray-600 overflow-hidden shadow z-[65]  py-[30px] rounded-l-2xl  transition-all flex flex-col  ${CtxNav.displayMenu ? 'right-0  duration-300 ' : 'right-[-500px]'} `}>
                <div className='w-full border-b-2 border-dayan-orange-50 py-[30px] flex flex-col items-center justify-center'>
                    <img src={CtxAuth.userInfo?.avatar} alt='avatar' className='w-[70px] h-[70px] shadow my-2 rounded-full' />
                    <span className='text-sm font-bold mt-3'>{CtxAuth.userInfo?.fname} {CtxAuth.userInfo?.lname}</span>
                </div>
                <div className='w-full flex flex-col pt-[30px]'>
                    {NavData.map((item: any, index: number) =>
                        <div onClick={() => handelChangeRoute(item.link)} className='w-full h-[40px] mb-2 flex items-center justify-between cursor-pointer'>
                            <div className='flex items-center'>
                                {item.icon}
                                <span className='text-sm text-[#252525] mr-2'>{item.name}</span>
                            </div>
                            <CSvgArrowRight className=' w-[15px] fill-dayan-orange-50 rotate-180' />
                        </div>
                    )}
                    <div onClick={handelExit} className='w-full h-[40px] mb-2 flex items-center justify-between cursor-pointer'>
                        <div className='flex items-center'>
                            <CSvgLogout className=' w-[20px]' />
                            <span className='text-sm text-[#252525] mr-2'>خروج</span>
                        </div>
                        <CSvgArrowRight className=' w-[15px] fill-dayan-orange-50 rotate-180' />
                    </div>
                </div>
            </div>
        </>
    );
}



const NavData = [
    {
        'name': 'ثبت تردد',
        'link': '/p/record',
        'icon': <CSvgPlusCircle className='fill-[#252525] w-[20px]' />
    },
    {
        'name': 'گزارش تردد',
        'link': '/p/rollcall',
        'icon': <CSvgReport className='fill-[#252525] w-[20px]' />
    },
    {
        'name': 'مرخصی',
        'link': '/p/vacation',
        'icon': <CSvgMoon className=' w-[20px]' />
    },
    {
        'name': 'تاخیر',
        'link': '/p/delay',
        'icon': <CSvgClock className='fill-[#252525] w-[20px]' />
    },
    {
        'name': 'اضافه کاری',
        'link': '/p/overtime',
        'icon': <CSvgChart className='fill-[#252525] w-[20px]' />
    },
    {
        'name': 'غیبت',
        'link': '/p/absence',
        'icon': <CSvgMinusCircle className='fill-[#252525] w-[18px]' />
    },
    {
        'name': 'ویرایش پروفایل',
        'link': '/p/profile',
        'icon': <CSvgCog className='fill-[#252525] w-[20px]' />
    },
    {
        'name': 'راهنما',
        'link': '/p/help',
        'icon': <CSvgHelp className='fill-[#252525] w-[20px]' />
    },
]